import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
  name: 'undefinedToString'
})
export class UndefinedToStringPipe implements PipeTransform {

  /**
   * Convert a value to string or empty string if null
   * @param {string} value
   * @returns {string}
   */
  transform(value: string): string {
    if (!value) {
      return '';
    } else {
      return value;
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/pipes/undefined-to-string.pipe.ts